/* DE — Deutsch. Glossar: Licht / Dunkelheit · Finsternis / Morgenröte /
   Ewige Nacht / Schrein / Relikt / Tiefe / Funke / Lichtkraft. */
export const de = {
  ui: {
    'html.rotate': 'Gerät ins<br>Querformat drehen',

    'hud.level': 'LV {n}',
    'hud.gold': '{gem} {n}',
    'hud.eternalNight': '{spark} EWIGE NACHT',
    'hud.lightPower': '{bolt} SCHADEN ×1.6 · {s}s',
    'hud.boss': 'BOSS',
    'hud.coreLabel': 'KERN',
    'hud.heatLabel': 'hitze · licht {n}%',
    'hud.poleLo': 'ZORN +{n}%',
    'hud.poleHi': 'MORGEN +{n}%',

    'banner.cache': 'VERSTECK — Gold und Lichtblitz',
    'banner.font': 'QUELL — Heilung und Schadenskraft',
    'banner.relic': 'RELIKT — {name}',
    'banner.bossDown': '{name} BESIEGT',
    'banner.darkFork': 'SCHEIDEWEG',
    'banner.eliteWave': 'SCHATTENBRUCH',
    'banner.heattide': 'HITZEFLUT',
    'banner.anomaly': 'FINSTERNIS: {name}',
    'banner.evolution': 'EVOLUTION — {name}',
    'banner.synergy': 'SYNERGIE — {name}',
    'banner.forge': 'SCHMIEDE — {name}',
    'banner.overclock': 'ÜBERHITZUNG — {name}',
    'banner.enrage': '{name} — RASEREI',
    'banner.snare': 'FESSEL — HALTE DIE ZONE!',
    'banner.snareWin': 'HERD ENTFACHT!',
    'banner.snareDefend': 'HERD — VERTEIDIGE!',
    'banner.snareDefendWin': 'HERD GEHALTEN!',
    'banner.snareFail': 'HERD ERLOSCHEN!',
    'banner.snareWaveCleared': 'WELLE ABGEWEHRT',
    'hud.snareWave': 'welle {n}/{total}',
    'hud.snareNextWave': 'nächste welle',
    'banner.revive': 'ZWEITER ATEM',
    'banner.dawn': '{spark} MORGENRÖTE {spark}',

    'menu.tagline': 'Wachse. Oder erkalte.',
    'menu.subtitle': 'S U R V I V O R S',
    'menu.start': '{play} SPIELEN',
    'menu.shop': '{gem} LICHTLADEN',
    'menu.moveKeyboard': 'WASD / Pfeile — Bewegung      Waffen feuern von selbst',
    'menu.moveTouch': 'Finger ziehen — Bewegung      Waffen feuern von selbst',
    'menu.hintCollect': 'Funken sammeln → Levelaufstieg → Verbesserung wählen',
    'menu.hintDawn': 'überlebe bis zur Morgenröte (10:00) → dann ewige Nacht. geh zum {spark} Licht in der Ferne',
    'menu.best': 'bester Lauf: {time}',
    'menu.depthStat': 'Tiefe: {n}/{total}',
    'menu.codexStat': 'Kodex: {n}/{total}',
    'menu.settings': '{gear} EINSTELLUNGEN',

    'charselect.title': 'WÄHLE DEINEN FUNKEN',
    'charselect.controls': '← →  wählen   ·   Enter / Klick — in den Kampf',
    'charselect.locked': '???',
    'charselect.lockedFallback': 'gesperrt',
    'charselect.surface': 'Oberfläche',
    'charselect.depthTitle': 'TIEFE DER FINSTERNIS   ( ↑ ↓  oder Klick ◂ ▸ )',
    'charselect.pathTitle': 'PFAD   ( Q E  oder Klick ◂ ▸ )',
    'charselect.depthReward': '{desc}   ·   Belohnung ×{mult}',
    'charselect.depthLocked': 'überlebe bis zur Morgenröte (10:00) — schaltet die Tiefe der Finsternis frei (mehr Gefahren und Belohnungen)',

    'shop.title': 'LICHTLADEN',
    'shop.back': '← ZURÜCK',
    'shop.controls': '↑ ↓  wählen   ·   Enter / Klick — kaufen   ·   Esc / M — zurück',
    'shop.max': 'MAX',
    'shop.trackForge': 'SCHMIEDE',
    'shop.trackHearth': 'TIEGEL',

    'draft.shrineTitle': '{spark} SCHREIN {spark}',
    'draft.eventTitle': 'SCHEIDEWEG',
    'draft.anomalyTitle': '{moon} SCHWUR DER DUNKELHEIT {moon}',
    'draft.levelTitle': 'LEVEL {n}',
    'draft.shrineHint': 'wähle ein Relikt  ·  dauerhaft für den Lauf  ·  1 / 2 / 3',
    'draft.eventHint': 'wähle einen Pfad  ·  keine richtige Antwort  ·  1 / 2 / 3',
    'draft.anomalyHint': 'forme diese Nacht  ·  kein Zurück  ·  noch {n}',
    'draft.levelHint': 'wähle eine Verbesserung  ·  1 / 2 / 3  oder  Klick',
    'draft.reroll': '{cycle} neu mischen  ·  R  ·  einmal pro Lauf',
    'draft.snareTitle': 'FESSEL — HALTE DIE ZONE',
    'draft.snareHint': 'wähle eine Stütze  ·  bleib in der Zone — Glut wächst  ·  1 / 2 / 3',
    'draft.snareDefendTitle': 'HERD — VERTEIDIGE',
    'draft.snareDefendHint': 'wähle eine Stütze  ·  verteidige den Kern vor dem Schwarm  ·  1 / 2 / 3',
    'draft.new': 'NEU',
    'draft.lvlChange': 'St. {a} → {b}',

    'kind.event': 'GABELUNG',
    'kind.evolve': '{star} EVOLUTION {star}',
    'kind.anomaly': '{moon} SCHWUR',
    'kind.relic': '{spark} RELIKT',
    'kind.weapon': 'WAFFE',
    'kind.passive': 'PASSIV',
    'kind.bonus': 'BONUS',
    'kind.boon': 'STÜTZE',
    'kind.forge': 'SCHMIEDE',
    'kind.overclock': 'ÜBERHITZUNG',
    'forge.ocName': 'Überhitzung: {w}',
    'forge.ocDesc': 'Über dem Limit (St. 5) — Macht gegen Licht. +{dmg}% Schaden · −{cost} Licht · Stufe {n}/{max}',

    'heal.name': 'Heilung',
    'heal.desc': '25% HP wiederherstellen',

    'pause.title': 'PAUSE',
    'pause.stats': 'St. {lvl}   ·   {time}   ·   {skull} {kills}   ·   Licht {light}',
    'pause.weapons': 'WAFFEN',
    'pause.passives': 'PASSIVE',
    'pause.relics': 'RELIKTE',
    'pause.synergies': 'SYNERGIEN',
    'pause.victory': '{spark} MIT DER MORGENRÖTE GEHEN — SIEG (V)',
    'pause.resume': '{play} WEITER (ESC)',
    'pause.quit': 'ZUM MENÜ (Q)',
    'pause.settings': '{gear} EINSTELLUNGEN',

    'settings.title': 'EINSTELLUNGEN',
    'settings.back': '← ZURÜCK',
    'settings.volume': 'LAUTSTÄRKE',
    'settings.crt': 'RETRO-CRT-EFFEKT',
    'settings.language': 'SPRACHE',
    'settings.on': 'AN',
    'settings.off': 'AUS',

    'results.dead': 'DU BIST GEFALLEN',
    'results.finale': 'DIE TIEFE IST BEZWUNGEN',
    'results.survived': 'DU HAST ÜBERLEBT!',
    'results.finaleSub': '{star} Die Finsternis ist nicht mehr. Du bist die ewige Morgenröte. {star}',
    'results.winSub': 'Das Licht bezwang die Finsternis. Du wurdest zur Morgenröte.',
    'results.demoTitle': 'DEMO ABGESCHLOSSEN',
    'results.demoSub': 'Vollversion: Tiefen der Finsternis · zweite Bossphasen · mehr Helden, Waffen & Pfade',
    'results.time': 'Überlebt',
    'results.level': 'Level',
    'results.kills': 'Tötungen',
    'results.bosses': 'Bosse',
    'results.score': 'Punkte',
    'results.gold': 'Gold',
    'results.relics': 'RELIKTE',
    'results.unlocked': '{spark} FREIGESCHALTET: {names}',
    'results.restart': '{play}  LEERTASTE / KLICK  —  NEUER LAUF',
    'results.menu': 'M  /  Klick  —  Menü und Laden',

    'speak.continue': 'Klick / Leertaste — weiter',

    'rarity.rare': 'SELTEN',
    'rarity.legend': 'LEGENDÄR',

    'unit.dmg': 'Schaden',
    'unit.speed': 'Tempo',
    'unit.enemySlow': 'Gegnertempo',
    'unit.regen': 'HP/Sek.',
    'unit.radius': 'Aufsammelradius',
    'unit.hp': 'max. HP',
    'unit.crit': 'Krit-Chance',
    'unit.cooldown': 'Abklingzeit',
    'unit.leech': 'HP pro Tötung',
  },

  data: {
    enemies: {
      chaser: { name: 'Schatten' }, swarm: { name: 'Irrlicht' }, tank: { name: 'Bürde' },
      spitter: { name: 'Speier' }, devourer: { name: 'Verschlinger' }, splitter: { name: 'Spalter' },
      splitling: { name: 'Scherbe' }, anchor: { name: 'Anker' }, leech: { name: 'Zerstreuer' },
      brute: { name: 'Koloss' }, boss: { name: 'Schnitter' }, boss2: { name: 'Finsternis' },
      boss3: { name: 'Herr der Finsternis' }, boss4: { name: 'Nullpunkt' },
      diver: { name: 'Stürmer' }, sniper: { name: 'Stachel' }, boss5: { name: 'Titan' },
    },
    characters: {
      spark:  { name: 'Funke',      desc: 'In allem ausgewogen. Start: Impuls.' },
      ember:  { name: 'Glut',       desc: 'Glaskanone: +25% Schaden, aber weniger HP und Hitze. Start: Impuls.' },
      umbra:  { name: 'Schwelend',  desc: 'Brennt hell, doch kurz: Hitze schwindet, jede Tötung — ein Moment mehr. Start: Impuls.' },
      mirror: { name: 'Gewandelt',  desc: 'Hitze entsteht aus Tötungen; Schaden löscht sie. Start: Glutsphäre.' },
    },
    shop: {
      maxhp:  { name: 'Härtung',      desc: '+12 max. HP pro Stufe' },
      power:  { name: 'Zorn',         desc: '+5% Schaden pro Stufe' },
      speed:  { name: 'Flinkheit',    desc: '+4% Tempo pro Stufe' },
      light:  { name: 'Strahlkraft',  desc: '+20 Hitze pro Stufe' },
      revive: { name: 'Zweiter Atem', desc: 'Einmal beim Tod auferstehen' },
      reroll:  { name: 'Zusätzliche Kohle', desc: '+1 Draft-Mischen pro Lauf' },
      beacons: { name: 'Schrein-Gedächtnis', desc: 'Schreine brennen öfter' },
      trove:   { name: 'Reliquiar',         desc: '+1 Relikt zur Schrein-Auswahl' },
      anoma:   { name: 'Anomalie-Schmiede', desc: '+1 Schwur-Wahl beim Start' },
    },
    weapons: {
      bolt:      { name: 'Stoß',         desc: 'Ein Hitzestoß trifft den Nächsten' },
      orbit:     { name: 'Glutsphäre',   desc: 'Hitzesphären kreisen um dich' },
      nova:      { name: 'Stichflamme',  desc: 'Eine Druckwelle aus Hitze um dich' },
      whip:      { name: 'Peitsche',     desc: 'Ein Hieb in deine Laufrichtung' },
      chain:     { name: 'Lauffeuer',    desc: 'Feuer springt zwischen Feinden' },
      mine:      { name: 'Glimmer',      desc: 'Eine glimmende Glut flammt am Feind auf' },
      beam:      { name: 'Hitzestrahl',  desc: 'Stetiger sengender Strahl in Blickrichtung' },
      lantern:   { name: 'Esse',         desc: 'Setzt eine Hitzezone: bremst und brennt' },
      duskblade: { name: 'Aschklinge',   desc: 'Klinge aus Asche: trifft härter, je weniger Hitze' },
      ricochet:  { name: 'Querschläger', desc: 'Prallt vom Dunkel ab und sammelt Hitze' },
      dawnflash: { name: 'Ausbruch',     desc: 'Ult: ein Hitzeausbruch über den Bildschirm' },
    },
    evolutions: {
      dawnray:      { name: 'Salve',          desc: 'Salve zielsuchender Funken, durchschlägt alles' },
      corona:       { name: 'Korona',         desc: 'Ein Ring aus Hitzesphären kreist um dich' },
      supernova:    { name: 'Großbrand',      desc: 'Verheerende Hitzewelle über den ganzen Bildschirm' },
      solaredge:    { name: 'Peitschenfächer',desc: 'Schneidet in alle Richtungen zugleich' },
      tempest:      { name: 'Feuersturm',     desc: 'Feuer trifft alle in der Nähe zugleich' },
      beacon:       { name: 'Glutfeld',       desc: 'Ein Feld berstender Glut-Fallen' },
      sunlance:     { name: 'Durchbrand',     desc: 'Breiter Hitzestrahl durchbrennt eine ganze Reihe' },
      lighthouse:   { name: 'Feuerschale',    desc: 'Riesige Hitzezone — eine Festung hält die Nacht' },
      eclipseblade: { name: 'Aschefächer',    desc: 'Ein Fächer aus Aschklingen durchbohrt die Reihe' },
      prism:        { name: 'Prisma',         desc: 'Ein Strahl spaltet sich und prallt endlos ab' },
      daybreak:     { name: 'Eruption',       desc: 'Bildschirmweite Hitze-Eruption blendet das Dunkel' },
    },
    passives: {
      speed:  { name: 'Beschleunigung', desc: '+Bewegungstempo' },
      power:  { name: 'Macht',          desc: '+gesamter Schaden' },
      regen:  { name: 'Regeneration',   desc: '+HP-Erholung' },
      magnet: { name: 'Magnet',         desc: '+Aufsammelradius' },
      vigor:  { name: 'Zähigkeit',      desc: '+max. HP' },
      crit:   { name: 'Präzision',      desc: 'Kritische-Treffer-Chance (×2.2)' },
      haste:  { name: 'Schnellfeuer',   desc: '−Abklingzeit aller Waffen' },
      leech:  { name: 'Hitzeernte',     desc: 'Heilt HP pro Tötung' },
      bloom:  { name: 'Aufblühen',      desc: 'Getötete bersten vor Hitze' },
      frost:  { name: 'Frost',          desc: 'Aura verlangsamt die Finsternis um dich' },
      pulse:  { name: 'Hitzepuls',      desc: 'Treffer an dir → eine Hitzewelle' },
    },
    forgeMods: {
      bolt_core:     { name: 'Glühender Kern', desc: 'Impuls trifft härter (+35%) und durchschlägt 1 Ziel' },
      bolt_shrapnel: { name: 'Schrapnell',     desc: 'Splittert zur Salve: +2 Geschosse, je schwächer — ein Feuerteppich' },
      bolt_armor:    { name: 'Panzerbrecher',  desc: 'Ein schwerer Stab: durchschlägt die ganze Reihe, aber weniger Geschosse' },
      orbit_core:    { name: 'Glühender Ring',     desc: 'Sphären brennen heißer (+30%) und der Ring ist breiter — mehr Kontakt' },
      orbit_swarm:   { name: 'Funkenschwarm',      desc: '+2 Sphären, jede schwächer — ein dichtes Karussell' },
      orbit_one:     { name: 'Tod durch eine',     desc: 'Eine Sphäre weniger, dafür schwer: ×1.9 Schaden und größer' },
      whip_core:     { name: 'Geschmiedeter Schwung', desc: 'Schlag trifft härter (+30%) und stößt stärker zurück' },
      whip_sweep:    { name: 'Weiter Schwung',     desc: 'Bogen 70% breiter und fegt doppelt so hart — Massenkontrolle, schwächer pro Ziel' },
      whip_harpoon:  { name: 'Harpune',            desc: 'Eine lange schmale Lanze: doppelte Reichweite und schwerer, aber ein dünnes Band' },
      bolt_split:    { name: 'Spaltung im Flug',   desc: 'Beim Treffer spaltet sich der Impuls in 2 zielsuchende Splitter' },
      whip_grasp:    { name: 'Griff',              desc: 'Die Peitsche ZIEHT Feinde in die Hitzegrenze, statt sie zurückzustoßen' },
    },
    relics: {
      ember:    { name: 'Glut der Morgenröte', desc: '+22% Schaden dauerhaft' },
      bulwark:  { name: 'Bollwerk',            desc: '+45 max. HP, +0,8 HP/Sek.' },
      swift:    { name: 'Kurier',              desc: '+14% Tempo, ×1,8 Magnet' },
      radiance: { name: 'Strahlkraft',         desc: '+90 Hitzeradius' },
      overload: { name: 'Überladung',          desc: 'Waffen feuern 18% schneller' },
      famine:   { name: 'Durst',               desc: 'Heilt 0,9 HP pro Tötung' },
      thorns:   { name: 'Zornkranz',           desc: 'Hitze verbrennt ständig Feinde um dich' },
      greed:    { name: 'Gier',                desc: '×1,6 Gold bis Laufende' },
      umbralward: { name: 'Glutzorn',          desc: 'Je geringer die Hitze, desto härter der Schlag: bis +60% im Dunkeln' },
      dawncrown:  { name: 'Morgenkrone',       desc: 'Je weiter die Hitze, desto härter der Schlag: bis +45% im Licht' },
    },
    depths: {
      0: { name: 'Tiefe I',   desc: 'Die Kälte verdichtet sich. Die Hitze schwindet.' },
      1: { name: 'Tiefe II',  desc: 'Feinde zäher, die Nacht näher.' },
      2: { name: 'Tiefe III', desc: 'Die Hitze hält kaum noch.' },
      3: { name: 'Tiefe IV',  desc: 'Der Abgrund blickt zurück.' },
      4: { name: 'Tiefe V',   desc: 'Nur die Morgenröte kann dich retten.' },
      5: { name: 'Tiefe VI',  desc: 'Das Ende der Hitze.' },
    },
    anomalies: {
      twilight:  { name: 'Zwielicht',         desc: 'Hitzeradius −22%' },
      longnight: { name: 'Lange Nacht',       desc: 'Treffer löschen mehr Hitze' },
      swarmtide: { name: 'Schwarmflut',       desc: 'Doppelt so viele kleine Kreaturen' },
      frenzy:    { name: 'Raserei',           desc: 'Feinde schneller, aber mehr Gold' },
      gloom:     { name: 'Düsternis',         desc: 'Schwächerer Magnet, dafür fetteres XP' },
      embertide: { name: 'Anfachen',          desc: 'Hitze wächst schneller, doch die Kälte drückt' },
      famine:    { name: 'Hunger',            desc: 'Die Finsternis gebiert größere Kreaturen' },
      fragile:   { name: 'Zerbrechlichkeit',  desc: 'Feinde treffen härter, sterben aber leichter' },
      embervow:  { name: 'Aschegelübde',      desc: 'Hitze schrumpft, doch im Dunkeln wächst der Zorn' },
    },
    darkEvents: {
      eliteWave: { name: 'Schattenbruch',             desc: 'Eine Welle zäher Kreaturen auf einmal — aber ein üppiger Goldregen' },
      curse:     { name: 'Verdichtung der Finsternis', desc: 'Eine neue dunkle Regel bis Laufende — dafür +15% Schaden dauerhaft' },
      respite:   { name: 'Atempause',                 desc: 'Nahe Kälte vertreiben, +50% HP, Hitze flammt auf' },
      fortune:   { name: 'Streufund',                 desc: 'Üppiger Goldregen und etwas Gesundheit' },
      heattide:  { name: 'Hitzeflut',                 desc: 'Die Hitze kocht über: ×1,5 Schaden für eine Weile und ein Radius-Aufflammen' },
      rift:      { name: 'Riss',                      desc: 'Lässt ein Relikt fallen — doch der Riss lässt die Kälte herein' },
    },
    shrineKinds: {
      relic: { name: 'Schrein' }, cache: { name: 'Versteck' }, font: { name: 'Quelle' }, snare: { name: 'Fessel' },
    },
    snareBoons: {
      bulwark:  { name: 'Bollwerk',    desc: '−55% erlittener Schaden beim Halten' },
      overheat: { name: 'Überhitzung', desc: 'Waffen feuern ×2 schneller, +25% Schaden' },
      pulsar:   { name: 'Pulsar',      desc: 'Hitzewellen stoßen den Schwarm zurück und verbrennen ihn' },
    },
    synergies: {
      ashEcho:      { name: 'Aschenecho' },
      darkForge:    { name: 'Schmiede der Finsternis' },
      smolderfield: { name: 'Glimmfeld' },
      sunPillar:    { name: 'Sonnensäule' },
      heatCorona:   { name: 'Hitzekorona' },
      dawnSalvo:    { name: 'Morgensalve' },
      fireWhirl:    { name: 'Feuerwirbel' },
    },
    paths: {
      wanderer: { name: 'Wanderer',        desc: 'Ein schlichter Anfang — der Pfad ist offen, kein Gelübde.' },
      ash:      { name: 'Pfad der Asche',  desc: 'Dunkler Build von Beginn: Start unter dem Aschegelübde mit Glutzorn.' },
      dawn:     { name: 'Pfad der Morgenröte', desc: 'Heller Build von Beginn: Start mit der Morgenkrone und steter Hitze.' },
      swarm:    { name: 'Pfad des Schwarms', desc: 'Gegen die Masse: Start mit Lauffeuer und einem Magneten.' },
    },
    unlocks: {
      beam:      { hint: 'Überlebe bis 4:00' },
      lantern:   { hint: 'Besiege den ersten Boss' },
      duskblade: { hint: 'Töte 1500 Kreaturen (gesamt)' },
      ricochet:  { hint: 'Erreiche Level 14 in einem Lauf' },
      dawnflash: { hint: 'Erreiche die Morgenröte (10:00)' },
      umbra:     { hint: 'Besiege einen Boss' },
      mirror:    { hint: 'Betritt die Tiefe der Finsternis' },
      ash:       { hint: 'Besiege den ersten Boss' },
      swarm:     { hint: 'Töte 2000 Kreaturen (gesamt)' },
      dawn:      { hint: 'Erreiche die Morgenröte (10:00)' },
      shrines:   { hint: 'Freigeschaltet: Schreine — Leuchtfeuer in der Ferne bergen Relikte, erreiche sie' },
      events:    { hint: 'Freigeschaltet: Dunkle Weggabelungen — eine Risiko-Wahl ohne richtige Antwort' },
      anomalies: { hint: 'Freigeschaltet: Gelübde der Finsternis — wähle, welche Dunkelheit der Lauf wird' },
    },
  },

  // ASCHENFELD-Lore (§14) — Stimmen-Fragmente. Eisberg: benennt Zustand/Bild, erklärt nie.
  lore: {
    runNames: [
      'Die Letzte Wärme', 'Asche des Dritten', 'Die Ecke, Die Sich Erinnert', 'Vor der Ersten Schicht',
      'Fremdes Brennen', 'Der Ebene Ort', 'Bevor Du ein Streifen Wurdest', 'Unter der Kälte',
      'Wo die Form Endet', 'Wärmer als Zuvor', 'Abdruck', 'Schicht Null',
    ],
    death: [
      'Wärme entweicht schneller, als du denkst.',
      'Erst schärfer. Dann ebenmäßig. Dann nichts.',
      'Zuerst die Kanten.',
      'Asche erinnert sich nicht, was sie war.',
      'Die Form hielt länger, als sie sollte.',
      'Irgendwo hier begannst du, wie alles andere auszusehen.',
      'Das Letzte, was geht, ist der Name.',
      'Erkalten heißt zustimmen.',
      'Du branntest wärmer als sie. Es reichte nicht.',
      'Die Geometrie schloss sich.',
      'Jemand brannte hier vor dir. Kam auch weit.',
      'Nicht erloschen. Nur — ununterscheidbar.',
    ],
    shrineRelic: [
      'Jemand hielt das, als es noch warm war.',
      'Nicht deine Form. Doch — Wärme.',
      'Sie brannten anders. Das ist geblieben.',
    ],
    shrineCache: [
      'Ordentlich verstaut. Als wollte jemand zurückkehren.',
      'Asche ringsum. Hier nicht.',
      'Nicht weggeworfen. Versteckt.',
    ],
    shrineFont: [
      'Woher die Wärme kommt — unklar. Sie kommt einfach.',
      'Hier hält die Form von selbst.',
      'Tiefer ist wärmer. Das hätte beruhigen sollen.',
    ],
    victory: [
      'Du bist raus. Oder man ließ dich raus.',
      'Tiefer als das hast du nie gebrannt.',
      'Du erkaltetest nicht. Das genügte.',
    ],
    menuEarly: [
      'Du hast den Ort nicht erreicht, wo die Form sich zu ändern beginnt.',
      'Ein Funke. Vorerst nur ein Funke.',
    ],
    menuDeep: [
      'Tiefer warst du nie. Hier ist die Asche anders.',
    ],
    menuStreak: [
      'So oft erkaltet. Und brennst wieder.',
      'Dreimal so weit. Jemand sieht es.',
    ],
    menuReturn: [
      'Du bist zurück. Das Aschenfeld ist nicht überrascht.',
    ],
    menuDefault: [
      'Entweder ist es Stärke. Oder du merkst den Unterschied nicht.',
      'Wieder warm. Das ist schon etwas.',
    ],
  },
};
